import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

import withProp from '../../../utils/withProp'

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  ${p => p.right && `text-align: right;`}
  ${p => p.left && `text-align: left;`}
  ${p => p.center && `text-align: center; `}

  &:not(:last-child) {
    margin-bottom: 1.25rem;
  }
`

export const THead = styled.thead`
  font-size: 0.75rem;
  line-height: 0.875rem;
  text-transform: uppercase;
  ${withProp('color')};
  ${withProp('fontSize', 'font-size')};

  ${({ borderBottom }) =>
    borderBottom &&
    `
    & td,
    & th {
      padding: 0.625rem 0.3125rem;
      border-bottom: 1px solid ${color.SILVER};
      color: ${color.GREY};
    }
  `}
`

export const TBody = styled.tbody`
  font-size: 1.125rem;
  line-height: 1.5625rem;
  ${withProp('fontSize')('font-size')};
`

export const Tr = styled.tr`
  ${withProp('color')};
  border-bottom: 1px solid ${color.SILVER};
  ${p => p.noBorder && `border-bottom: none;`}
`

export const Td = styled.td`
  padding: 0 0.3125rem;
  color: ${color.MORTAR};

  ${p => p.right && `text-align: right;`}
  ${p => p.left && `text-align: left;`}
  ${p => p.center && `text-align: center; `}

  ${({ important }) =>
    important &&
    `
    font-size: 1.5rem;
    color: ${color.MORTAR};
  `}

  ${p =>
    p.min &&
    `
    width:10%;
  `}

  ${({ error }) =>
    error &&
    `
    color: ${color.WATERMELON};
  `}

  ${p =>
    p.bold &&
    `
    font-family: 'sidecarta-sans-bold', sans-serif;
  `}

  ${TBody} & {
    padding-top: 0.9375rem;
    padding-bottom: 0.9375rem;
  }

  ${withProp('align', 'text-align')};
  ${withProp('width')};
  ${withProp('minWidth', 'min-width')};
  ${withProp('color')};
`

export default Table
